import { useCallback } from 'react';
import { ACTION_BY } from '../../../../common/constant/constant';
import type { SelectAnnotationPayloadT } from '../../../../common/side-panel/analytics/types';
import useAnalyticsForSidePanel from '../../../../common/side-panel/analytics/useAnalyticsForSidePanel';
import { SIDE_PANEL_ACTIONS } from '../../const';
import { useDispatch } from '../../hooks/use-dispatch';
import { useSelectedAnnotationLabel } from '../../hooks/use-selected-annotation-label';
import type { ModernizedGenericAnnotation } from '../../types';
type Props = {
  annotations: ModernizedGenericAnnotation[];
};
export function useAnnotationItemContainerActions({}: Props) {
  const dispatch = useDispatch();
  const selectedAnnotationLabel = useSelectedAnnotationLabel();
  const {
    sendEventForAnnotationSelection
  } = useAnalyticsForSidePanel();
  const handleHover = useCallback((annotationId: string | null) => {
    dispatch({
      type: SIDE_PANEL_ACTIONS.SET_FOCUSED_ANNOTATION,
      annotationId: annotationId || ''
    });
  }, [dispatch, sendEventForAnnotationSelection, selectedAnnotationLabel]);
  const handleClick = useCallback((annotationId: string) => {
    dispatch({
      type: SIDE_PANEL_ACTIONS.SELECT_ANNOTATION,
      annotationId
    });
    const eventPayload: SelectAnnotationPayloadT = {
      objectType: SIDE_PANEL_ACTIONS.SELECT_ANNOTATION,
      label: selectedAnnotationLabel?.title ?? '',
      objectId: annotationId,
      actionBy: ACTION_BY.EDIT
    };
    sendEventForAnnotationSelection(eventPayload);
  }, [dispatch, sendEventForAnnotationSelection, selectedAnnotationLabel]);
  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLDivElement>, annotationId: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(annotationId);
    }
  }, [handleClick]);
  return {
    onMouseEnter: handleHover,
    onMouseLeave: handleHover,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  };
}